import {
  createFacebookAdLoading,
  createFacebookAdSuccess,
  createFacebookAdFailure,
} from "@redux/slices/facebookAdsSlice"
import { createFacebookAd } from "@services/facebookAds/createFacebookAd"
import { notify } from "@utils/notify"
import { useDispatch } from "react-redux"
import useAdPostAttempts from "./useAdPostAttempts"

//const userId = import.meta.env.VITE_USER_ID


const useFacebookAds = () => {
  const userId = localStorage.getItem("userId")
  const dispatch = useDispatch()
  const { handleCreateAdPostAttempt } = useAdPostAttempts()

  const handleCreateFacebookAd = async (adAccountId, data) => {
    try {
      dispatch(createFacebookAdLoading())
      const response = await createFacebookAd(adAccountId, data)
      dispatch(createFacebookAdSuccess(response.data))
      await handleCreateAdPostAttempt({
        ad_details: {
          req_payload: data,
          adAccountId: adAccountId,
          response: response.data,
        },
        userId: userId,
      })
      return response.data
    } catch (error) {
      await handleCreateAdPostAttempt({
        ad_details: {
          req_payload: data,
          adAccountId: adAccountId,
          response: error?.response?.data || error.message,
        },
        userId: userId,
      })
      dispatch(createFacebookAdFailure(error.message))
      notify("Error creating ad", "error")
    }
  }

  return {
    handleCreateFacebookAd,
  }
}

export default useFacebookAds
